import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
export var replace = normalize.replace(function (options) {
  var _ref = options || {},
    url = _ref.url,
    _ref$isHash = _ref.isHash,
    isHash = _ref$isHash === void 0 ? false : _ref$isHash,
    _ref$refresh = _ref.refresh,
    refresh = _ref$refresh === void 0 ? true : _ref$refresh,
    success = _ref.success,
    fail = _ref.fail,
    complete = _ref.complete;
  var _url = isHash ? "/#" + url : url;
  setTimeout(function () {
    try {
      // eslint-disable-next-line @iceworks/best-practices/no-http-url
      if ((url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1) && url.indexOf(location.origin) === -1) {
        console.warn('Uni API: Replace does not support cross-domain');
        location.href = url;
        return;
      }
      if (isHash) {
        var _location = location,
          href = _location.href;
        var index = href.indexOf('#');
        // 域名不变的情况下不会刷新页面
        window.location.replace(index > 0 ? href.slice(0, index) + "#" + url : href + "#" + url);
      } else {
        window.history.replaceState(null, null, _url);
        refresh && location.reload();
      }
      success && success();
      complete && complete();
    } catch (e) {
      fail && fail(e);
      complete && complete(e);
    }
  });
}, CONTAINER_NAME.WEB);
export default replace;